module.exports = __webpack_public_path__ + "images/footer-bg.3a9d28.png";